export const info_page = {
	INFO_PAGE_HEADER: {
		value: 'GAME INFO',
		config: {
			fontName: 'custom_font',
			fontSize: 42,
			letterSpacing: 5,
			align: 'center'
		}
	},
	INFO_SLIDE_1_TITLE: {
		value: 'SYMBOL PAYOUTS',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28
		}
	},
	INFO_SLIDE_1_SUBTITLE: {
		value:
			'The quantity and types of symbols present on the line will determinate your wins.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center'
		}
	},
	INFO_SLIDE_1_NUMBER: {
		value: '',
		config: {
			fill: '#43B726',
			fontFamily: 'Poppins Bold',
			fontSize: 25
		}
	},
	INFO_SLIDE_1_COEF: {
		value: '',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Bold',
			fontSize: 25
		}
	},
	WILD_TITLE: {
		value: 'WILD',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28
		}
	},
	SCATTER_TITLE: {
		value: 'SCATTER',
		config: {
			fill: '#CEEE71',
			fontFamily: 'Poppins Bold',
			fontSize: 28
		}
	},
	SCATTER_SUBTITLE: {
		value:
			'If 3 or more Scatter symbol lands on the reel, it will trigger Bonus Game regardless of its position.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center'
		}
	},
	WILD_SUBTITLE: {
		value:
			'Wild symbol substitutes all symbols except the Scatter symbol and works for payline creation.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center'
		}
	},
	PAYLINES_TITLE: {
		value: 'WINNING PAYLINES',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28,
			align: 'center'
		}
	},
	PAYLINES_SUBTITLE: {
		value:
			'You have 20 consecutive paylines to land symbols on and determinate wins.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center'
		}
	},
	PAYLINES_NOTE: {
		value: '*All symbols pay from left to right adjacent reels',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center'
		}
	},
	INFO_WILD_TITLE: {
		value: 'BONUS GAME',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28,
			align: 'center'
		}
	},
	INFO_WILD_SUBTITLE: {
		value:
			'The Bonus Game has possibility of Re-trigger, which means if 3 or more scatter lands you will be rewarded with additional +10 Freespins',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_WILD_SUBTITLE_2: {
		value:
			'The Bonus Game also has Revive feature which offers you to continue the round where you ran out of Freespins',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_WILD_NOTE: {
		value:
			'Whenever 2 or more Wild Symbol lands on reel its multiplier is increased by 1x Maximum amount of multiplier possible is 5x',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_BONUS_TITLE: {
		value: 'PROGRESSIVE GAMEPLAY',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28,
			align: 'center'
		}
	},
	INFO_BONUS_SUBTITLE: {
		value:
			'The Bonus Game has a chance to land Special       symbol on the reel, which adds additional +1 Freespin and advances you to next step in progress platforms',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_BONUS_NOTE: {
		value:
			'After 3 Steps, you will catch the Heart        symbol and will be rewarded with additional +10 Freespins After completing all progress platforms, you will get the Star        symbol and be rewarded with an additional 10x Multiplier of your Bonus Game winnings.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 40
		}
	},
	INFO_CUSTOM_TEXT_SPIN: {
		value: '5',
		config: {
			fontName: 'custom_font',
			fontSize: 20
		}
	},
	INFO_QUEST_TITLE: {
		value: 'DAILY QUESTS',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28,
			align: 'center'
		}
	},
	INFO_QUEST_SUBTITLE: {
		value:
			'The game has a quest system that allows the player to receive specific rewards after completing predetermined tasks.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_QUEST_NOTE: {
		value:
			'The player is shown a quest section on the main game board called "THE LOST SCROLL" and has a timer that tells the player in how long the quests will reset.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_QUEST_NOTE_BOTTOM: {
		value:
			'The quest system consists of 4 sub-quests and the player must complete all 4 sub-quests to get the rewards.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 40
		}
	},
	INFO_QUEST_SUBTITLE_SECOND: {
		value:
			'Quests are reset every 24 hours, in case the player fails to complete all the quests, after this time his score will be reset and he will have to complete these quests all over again.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_QUEST_NOTE_SECOND: {
		value:
			'The content of the sub-quests of the quest system includes a task for the player to perform actions within the game, the task may include increasing the bet, determining the number of bets, hitting a specific symbol in an iteratively determined amount.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAME_SUBTITLE: {
		value: 'GAME SPECIFICATIONS',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAME_NOTE: {
		value:
			"Current game's volatility is High, which means that game pays out less frequently, but chances of big wins are increased.",
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAME_NOTE_SECOND: {
		value:
			'The max win is 5000X your bet, applicable in both base and bonus rounds. ',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAME_NOTE_THIRD: {
		value: 'Maximum Bet : 125.00 USD     Minimum Bet : 1.00 USD',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAME_NOTE_FOURTH: {
		value:
			'If the bonus round hits this cap, it ends immediately, awards the win, and forfeits any remaining spins.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAME_NOTE_FIFTH: {
		value: 'The Theoretical RTP of this game is 96.5%.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_DOUBLE_SUBTITLE: {
		value: 'DOUBLE CHANCE & BUY BONUS',
		config: {
			fill: '#71B2EE',
			fontFamily: 'Poppins Bold',
			fontSize: 28,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_DOUBLE_NOTE_SECOND: {
		value:
			'By switching the option your chances of triggering the necessary scatters (3, 4, or 5) for the bonus round are doubled.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_DOUBLE_NOTE_THIRD: {
		value:
			'The Bonus Game can immediately be triggered from the base by buying it.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_DOUBLE_NOTE_FOURTH: {
		value: 'This option will increase your bet amount by 25%.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_DOUBLE_NOTE_FIFTH: {
		value: 'Price for Buy Bonus is 200X of bet amount.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	BONUS_BUY_TITLE: {
		value: 'BUY BONUS',
		config: {
			fill: '#cfdbb5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	INFO_GAMEPLAY_NOTE_LEFT: {
		value: 'Player configures desired bet amount with',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAMEPLAY_NOTE_RIGHT: {
		value: 'increasing and decreasing buttons.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAMEPLAY_NOTE_SECOND_LEFT: {
		value: 'Configured bet amount itself is displayed on  ',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAMEPLAY_NOTE_SECOND_RIGHT: {
		value: 'with currency symbol or abbreviation.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAMEPLAY_NOTE_THIRD_LEFT: {
		value: 'IMG ',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAMEPLAY_NOTE_THIRD_RIGHT: {
		value:
			'opens the Settings menu that contains settings which affect the way the game is being played.',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	},
	INFO_GAMEPLAY_NOTE_FIFTH: {
		value: 'opens the information page',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins Regular',
			fontSize: 20,
			align: 'center',
			lineHeight: 35
		}
	}
};
